module.exports = __webpack_public_path__ + "static/Plaak - 23-Pradel-Light-205TF-f3d1c3e322380cd1ef10b0db9accab33.woff2";